<template>
  <a-form layout="vertical">
    <a-form-item :label="t('shell.account.currentPassword')" required>
      <a-input-password
        v-model:value="form.oldPassword"
        :placeholder="t('shell.account.currentPasswordPlaceholder')"
        autocomplete="current-password"
      />
    </a-form-item>
    <a-form-item :label="t('shell.account.newPassword')" required>
      <a-input-password
        v-model:value="form.newPassword"
        :placeholder="t('shell.account.newPasswordPlaceholder')"
        autocomplete="new-password"
      />
    </a-form-item>
    <a-form-item :label="t('shell.account.confirmPassword')" required>
      <a-input-password
        v-model:value="form.confirmPassword"
        :placeholder="t('shell.account.confirmPasswordPlaceholder')"
        autocomplete="new-password"
      />
    </a-form-item>
    <a-form-item>
      <a-button type="primary" :disabled="!dirty" @click="handleSave">
        {{ t('shell.account.savePassword') }}
      </a-button>
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { message } from 'ant-design-vue'
import { computed, reactive } from 'vue'
import { updatePassword } from '../../api/user/setting'
import { useI18n } from '../../composables/useI18n'

const { t } = useI18n()

const form = reactive({ oldPassword: '', newPassword: '', confirmPassword: '' })
const dirty = computed(() => !!form.oldPassword && !!form.newPassword && !!form.confirmPassword)

async function handleSave() {
  if (!form.oldPassword || !form.newPassword || !form.confirmPassword) {
    message.warning(t('shell.account.passwordAllRequired'))
    return
  }
  if (form.newPassword !== form.confirmPassword) {
    message.error(t('shell.account.passwordMismatch'))
    return
  }
  try {
    await updatePassword(form.oldPassword, form.newPassword)
    message.success(t('shell.account.passwordSuccess'))
    form.oldPassword = ''
    form.newPassword = ''
    form.confirmPassword = ''
  } catch (e: any) {
    message.error(e?.message || t('shell.account.updateFailed'))
  }
}
</script>
